export default function ( state=null, action ) {
    switch( action.type ) {

        case "TOGGLE_SLIDEOUT_PANEL":
        return action.payload;

        default:
        return state;
    }
}